import React, { useContext, useEffect, useState } from "react";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import "../Pages/Style/billsinvoice.css";
import BusinessPlanCard from "./BusinessPlanCard";
import "../Pages/Style/dashboard.css";
import "../../App.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import LogoutCard from "../Components/Card/LogoutCard";
import Footer from "../Components/Footer/Footer";
import SideBar from "../Components/SideBar/SideBar";
import TextLinkExample from "../Components/NavBar/NavBar";
import { SidebarContext } from "../../context/SidebarContext";
import { useCreateBusinessPlanMutation, useGetBusinessPlanQuery } from "../../redux/API/channelPartnerBusinessApi";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const BusinessPlan = () => {
  const [equityData, setEquityData] = useState({
    equityClients: "1",
    equityFamily: "",
    equityAverage: "",
    equitygrowth: "10",
  });
  const { isSiderbaropen } = useContext(SidebarContext);
  const [showLogout, setShowLogout] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const cpId = userData?.validateEmail && userData?.validateEmail[0]?._id;
  const [postData] = useCreateBusinessPlanMutation();
  const {data, refetch, isLoading} = useGetBusinessPlanQuery(cpId) 
  const [showBusinessCard, setShowBusinessCard] = useState(false);
  const [error, setError] = useState("")
useEffect(() => { 
  setShowBusinessCard(data?.designBusiness?.length === 0 ? false : true);
}, [data?.designBusiness]); 

  const handleChange = (e) => {
    const {name, value} = e.target
    setEquityData({...equityData, [name]: value})
  };
  
  

  const handleClick = (e) => {
    e.preventDefault();
    if(equityData.equityClients === "" || equityData.equityFamily === "" || equityData.equityAverage === "" || equityData.equitygrowth === ""){
      setError("Please fill all the fields to proceed with the business plan*")
      setTimeout(() => {
        setError("")
      }, 3000);
      return;
    }

    postData({
      cpid: cpId, 
      data: {
        equityClients: equityData.equityClients,
        equityFamily: equityData.equityFamily,
        equityAverage: equityData.equityAverage,
        equitygrowth: equityData.equitygrowth / 100,
      },
    }).then((res) => {
      if(res){

        setEquityData({
         equityClients: "1",
         equityFamily: "",
         equityAverage: "",
         equitygrowth: "10",
       });
       setShowBusinessCard(true);
       refetch()
      }
    });
  };

  return (
    <>
      <div className="App">
        <SideBar />
        <div className={!isSiderbaropen ? "pages" : "pages-change"}>
          <TextLinkExample setShowLogout={setShowLogout} />
          <div className=" BillsInvoice  min-vh-100 ">
            <div className="PortfolioReviewHeader mx-4 my-4 py-3 px-2">
              <h4 className="mb-0">Design Business Plan</h4>
            </div>
            {!isLoading &&  !showBusinessCard ? (
              <div className="PortfolioReviewTable mx-4 my-4">
                <div className="card p-3">
                  <form onSubmit={handleClick}>
                    <MDBTable
                      hover
                      striped
                      style={{
                        backgroundColor: "RGB(255 255 255)",
                        fontSize: "14px",
                      }}
                      className="verticle-table"
                    >
                      <MDBTableHead
                        style={{ backgroundColor: "#5A4344", color: "white" }}
                      >
                        <tr>
                          <th
                            scope="col"
                            style={{
                              width: "100px",
                              maxwidth: "100px",
                              minwidth: "100px",
                            }}
                          >
                            Projected Client & Business
                          </th>
                          <th
                            scope="col"
                            style={{
                              width: "100px",
                              maxwidth: "100px",
                              minwidth: "100px",
                            }}
                          >
                            Client per Family
                          </th>
                          <th
                            scope="col"
                            style={{
                              width: "100px",
                              maxwidth: "100px",
                              minwidth: "100px",
                            }}
                          >
                            No. of Family
                          </th>
                          <th
                            scope="col"
                            style={{
                              width: "120px",
                              maxwidth: "120px",
                              minwidth: "120px",
                            }}
                          >
                            Client growth per year (%)
                          </th>
                          <th
                            scope="col"
                            style={{
                              width: "120px",
                              maxwidth: "120px",
                              minwidth: "120px",
                            }}
                          >
                            Average Business per Client (Rs)
                          </th>
                        </tr>
                      </MDBTableHead>
                      <MDBTableBody>
                        <tr>
                          <td>Equity</td>
                          <td>
                            <input
                              id="equityClients"
                              name="equityClients"
                              type="text"
                              value={equityData.equityClients}
                              onChange={handleChange}
                            />
                          </td>
                          <td>
                            <input
                              id="equityFamily"
                              name="equityFamily"
                              type="text"
                              value={equityData.equityFamily}
                              onChange={handleChange}
                            />
                          </td>
                          <td>
                            <input
                              id="equitygrowth"
                              name="equitygrowth"
                              type="text"
                              value={equityData.equitygrowth}
                              onChange={handleChange}
                            />
                          </td>
                          <td>
                            <input
                              id="equityAverage"
                              name="equityAverage"
                              type="text"
                              value={equityData.equityAverage}
                              onChange={handleChange}
                            />
                          </td>
                        </tr>
                      </MDBTableBody>
                    </MDBTable>
                    <p className="text-danger mb-0">{error}</p>
                    <button
                      type="submit"
                      className="float-end border-0"
                      style={{
                        backgroundColor: "#9DC913",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        color: "white",
                      }}
                    >
                      Calculate
                    </button>
                  </form>
                </div>
              </div>
            ) : (
              <div className="PortfolioReviewTable mx-4 my-4">
                <BusinessPlanCard setShowBusinessCard={setShowBusinessCard} />
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
      {showLogout && <LogoutCard setShowLogout={setShowLogout} />}
    </>
  );
};

export default BusinessPlan;
